import { LoyaltyBenefitsGroupInterface } from '../types'
import { LOYALTY_BENEFITS_NAMES } from './benefitNames'
import { LOYALTY_LEVEL_NAMES } from './levelNames'

export * from './benefitNames'
export * from './levelColors'
export * from './levelNames'

export const LOYALTY_BENEFITS: LoyaltyBenefitsGroupInterface[] = [
  {
    name: LOYALTY_BENEFITS_NAMES.marketing,
    benefits: [
      {
        name: LOYALTY_BENEFITS_NAMES.promoCodes,
        tooltipTranslationKey: 'loyalty-program.benefits-group_marketing-promo-codes_tooltip',
        translationKey: 'loyalty-program.benefits-group_marketing-promo-codes',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.customPromo,
        tooltipTranslationKey: 'loyalty-program.benefits-group_marketing-custom-promo_tooltip',
        translationKey: 'loyalty-program.benefits-group_marketing-custom-promo',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.customTournaments,
        tooltipTranslationKey: 'loyalty-program.benefits-group_marketing-custom-tournaments_tooltip',
        translationKey: 'loyalty-program.benefits-group_marketing-custom-tournaments',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.featureAccess,
        tooltipTranslationKey: 'loyalty-program.benefits-group_marketing-feature-access_tooltip',
        translationKey: 'loyalty-program.benefits-group_marketing-feature-access',
      },
    ],
    imageAlt: 'Image of a speaker',
    imageSrc: '/assets/img/loyalty/speacker.png',
    levels: {
      [LOYALTY_LEVEL_NAMES.level02]: [LOYALTY_BENEFITS_NAMES.promoCodes],
      [LOYALTY_LEVEL_NAMES.level03]: [
        LOYALTY_BENEFITS_NAMES.promoCodes,
        LOYALTY_BENEFITS_NAMES.customPromo,
        LOYALTY_BENEFITS_NAMES.customTournaments,
        LOYALTY_BENEFITS_NAMES.featureAccess,
      ],
      [LOYALTY_LEVEL_NAMES.level04]: [
        LOYALTY_BENEFITS_NAMES.promoCodes,
        LOYALTY_BENEFITS_NAMES.customPromo,
        LOYALTY_BENEFITS_NAMES.customTournaments,
        LOYALTY_BENEFITS_NAMES.featureAccess,
      ],
      [LOYALTY_LEVEL_NAMES.level05]: [
        LOYALTY_BENEFITS_NAMES.promoCodes,
        LOYALTY_BENEFITS_NAMES.customPromo,
        LOYALTY_BENEFITS_NAMES.customTournaments,
        LOYALTY_BENEFITS_NAMES.featureAccess,
      ],
    },
    translationKey: 'loyalty-program.benefits-group_marketing',
  },
  {
    name: LOYALTY_BENEFITS_NAMES.vip,
    benefits: [
      {
        name: LOYALTY_BENEFITS_NAMES.sponsoredPayments,
        tooltipTranslationKey: 'loyalty-program.benefits-group_vip-sponsored-payments_tooltip',
        translationKey: 'loyalty-program.benefits-group_vip-sponsored-payments',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.giftBaskets,
        tooltipTranslationKey: 'loyalty-program.benefits-group_marketing-gift-baskets_tooltip',
        translationKey: 'loyalty-program.benefits-group_marketing-gift-baskets',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.personalizedGifts,
        tooltipTranslationKey: 'loyalty-program.benefits-group_vip-personalized-gifts_tooltip',
        translationKey: 'loyalty-program.benefits-group_vip-personalized-gifts',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.techGifts,
        tooltipTranslationKey: 'loyalty-program.benefits-group_vip-tech-gifts_tooltip',
        translationKey: 'loyalty-program.benefits-group_vip-tech-gifts',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.paidTrips,
        tooltipTranslationKey: 'loyalty-program.benefits-group_vip-paid-trips_tooltip',
        translationKey: 'loyalty-program.benefits-group_vip-paid-trips',
      },
      {
        name: LOYALTY_BENEFITS_NAMES.dailyPayouts,
        tooltipTranslationKey: 'loyalty-program.benefits-group_vip-daily-payouts_tooltip',
        translationKey: 'loyalty-program.benefits-group_vip-daily-payouts',
      },
    ],
    imageAlt: 'Image of a crown',
    imageSrc: '/assets/img/loyalty/crown.png',
    levels: {
      [LOYALTY_LEVEL_NAMES.level03]: [LOYALTY_BENEFITS_NAMES.sponsoredPayments],
      [LOYALTY_LEVEL_NAMES.level04]: [
        LOYALTY_BENEFITS_NAMES.sponsoredPayments,
        LOYALTY_BENEFITS_NAMES.giftBaskets,
        LOYALTY_BENEFITS_NAMES.personalizedGifts,
        LOYALTY_BENEFITS_NAMES.techGifts,
      ],
      [LOYALTY_LEVEL_NAMES.level05]: [
        LOYALTY_BENEFITS_NAMES.sponsoredPayments,
        LOYALTY_BENEFITS_NAMES.giftBaskets,
        LOYALTY_BENEFITS_NAMES.personalizedGifts,
        LOYALTY_BENEFITS_NAMES.techGifts,
        LOYALTY_BENEFITS_NAMES.paidTrips,
        LOYALTY_BENEFITS_NAMES.dailyPayouts,
      ],
    },
    translationKey: 'loyalty-program.benefits-group_vip',
  },
]

const getBenefitTranslationKey = (benefitName: LOYALTY_BENEFITS_NAMES): null | string =>
  LOYALTY_BENEFITS.flatMap(({ benefits }) => benefits).find(({ name }) => name === benefitName)?.translationKey ?? null

export const LOYALTY_MAIN_LEVEL_BENEFIT_TRANSLATION_KEYS: Record<LOYALTY_LEVEL_NAMES, null | string> = {
  [LOYALTY_LEVEL_NAMES.level01]: null,
  [LOYALTY_LEVEL_NAMES.level02]: getBenefitTranslationKey(LOYALTY_BENEFITS_NAMES.promoCodes),
  [LOYALTY_LEVEL_NAMES.level03]: getBenefitTranslationKey(LOYALTY_BENEFITS_NAMES.sponsoredPayments),
  [LOYALTY_LEVEL_NAMES.level04]: getBenefitTranslationKey(LOYALTY_BENEFITS_NAMES.personalizedGifts),
  [LOYALTY_LEVEL_NAMES.level05]: 'loyalty-program.progress-achievement-top-level-benefits',
}
